import { render, staticRenderFns } from "./SettingsSidemenu.vue?vue&type=template&id=98a5517c&scoped=true&"
import script from "./SettingsSidemenu.vue?vue&type=script&lang=js&"
export * from "./SettingsSidemenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSidemenu.vue?vue&type=style&index=0&id=98a5517c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a5517c",
  null
  
)

export default component.exports